import 'survey-core/defaultV2.min.css';

import React, { useEffect } from 'react';

import faker from 'faker';

import { Box, Container } from '@mui/material';

import { WithPatientTheme } from './Theme';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useSearchParams,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import MaskSelectorTool from './MaskSelectorTool';
import MaskSelectorToolStyles from 'ui_patient/pages/MaskSelectorTool/MaskSelectorToolStyles';

import { v2partialDataQuestionsNotAsked } from 'ui_patient/pages/MaskSelectorTool/testUtils';

import './App.css';

import CompletePage from 'ui_patient/pages/MaskSelectorTool/CompletePage';
import Header from 'ui_patient/pages/MaskSelectorTool/Header';
import Footer from 'ui_patient/pages/MaskSelectorTool/Footer';

// import CameraChoiceDialogTester from "./cameraChoiceDialog/CameraChoiceDialogTester";

// import SurveyContainerShell from "./SurveyContainerShell";
import RetryFaceScan from 'ui_patient/pages/MaskSelectorTool/RetryFaceScan';

// import { Model } from 'survey-core';
// import { Survey } from 'survey-react-ui';

// import * as surveyJson from './survey.json';

// tfjsWasm.setWasmPaths(`/wasm/tensorflow/tfjs-backend-wasm/${tfjsWasm.version_wasm}/dist/`);

// Global variable used for passing overrides from the disable question tester to
// UseState cannot be used because a router cannot be changed dynamically during routing.
let disable_question_overrides = [];

const setOverrides = overrides => {
  disable_question_overrides = overrides;
};

const hideScrollbar = () => {
  return {
    overflow: 'auto',
    scrollbarWidth: 'none', // Hide the scrollbar for firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
    },
    '&-ms-overflow-style:': {
      display: 'none', // Hide the scrollbar for IE
    },
  };
};

const RedirectHandler = () => {
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('center_id');
  const TOKEN = faker.random.uuid();
  return (
    <Navigate
      replace
      to={{
        pathname: '/d/start',
        search: `?center_id=${clientId}`,
      }}
      state={{ token: TOKEN, usePhoto: true }}
    />
  );
};

const MaskSelectorToolWrapper = ({
  customValidateTokenMethod,
  customSubmitLogic,
  routePrefixPath,
}) => {
  const [searchParams] = useSearchParams();
  const location = useLocation(); // Get the location object
  const navigate = useNavigate(); // Get the navigate function
  const clientId = searchParams.get('center_id');

  // Initialize token from location state, or create one if it doesn't exist
  useEffect(() => {
    // If location.state doesn't have a token, create one and update the state
    if (!location.state || !location.state.token) {
      const TOKEN = faker.random.uuid();
      // Navigate to the same location but with state
      navigate(location.pathname + location.search, {
        replace: true,
        state: { token: TOKEN, usePhoto: true },
      });
    }
  }, [location, navigate]);

  // If no client_id is present, redirect to root
  if (!clientId) {
    return <Navigate to="/" replace />;
  }
  return (
    <WithPatientTheme>
      <MaskSelectorTool
        customValidateTokenMethod={customValidateTokenMethod}
        customSubmitLogic={customSubmitLogic}
        routePrefixPath={routePrefixPath}
        clientId={clientId}
      />
    </WithPatientTheme>
  );
};

function App() {
  let TOKEN = faker.random.uuid();

  const v2NextGenValidateMethod = async token => {
    return {
      data: {
        mugshot_enabled: true,
        nextgen_enabled: true,
        skip_questions: true,
        token: token,
        hme_org_code: 'mugshotTools',
        hme_location_code: 'mugshotTools-loc1',
        patient_code: token,
      },
    };
  };

  const customSubmitLogic = async values => {
    console.log('Inside custom submit logic.');
    console.table(values);
  };

  // const survey = new Model(surveyJson);

  // console.log(survey)

  const { classes } = MaskSelectorToolStyles();

  const container_styles = `${classes.appRoot} ${classes.appRootPadding}`;

  const headerHeight = 53;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectHandler />} />

        <Route
          path="/d/:step?"
          element={
            <MaskSelectorToolWrapper
              // initialValues={v2PrelimData}
              customValidateTokenMethod={v2NextGenValidateMethod}
              customSubmitLogic={customSubmitLogic}
              routePrefixPath="d"
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
